// src/routes/dashboard/components/RequestDeadlineList.tsx
/** Lista di richieste con scadenza, riusata sia per "In ritardo" sia per "In scadenza (7 gg)". */
import React from 'react';
import { Badge, Card, Group, Stack, Text, Title, Box } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { HomeRequestItem } from '../../../types/api';
import { TYPE_META } from '../../../components/analytics/analytics-meta';
import { formatDaysToDue } from '../dashboard-meta';

interface RequestDeadlineListProps {
  title: string;
  items: HomeRequestItem[];
  totalCount: number;
  emptyLabel: string;
  tone: 'danger' | 'warning';
}

export function RequestDeadlineList({ title, items, totalCount, emptyLabel, tone }: RequestDeadlineListProps) {
  const navigate = useNavigate();

  const openRequest = (id: number) => {
    navigate({ to: `/requests/${id}`, search: { from: '/' } } as any);
  };

  return (
    <Card withBorder p="md" h="100%">
      <Title order={4} mb="sm">
        {title}
      </Title>

      {items.length === 0 ? (
        <Group c="dimmed" py="lg" justify="center">
          <IconCircleCheck size={18} />
          <Text size="sm">{emptyLabel}</Text>
        </Group>
      ) : (
        <Stack gap="xs">
          {items.map((item) => {
            const dueLabel = formatDaysToDue(item.daysToDue);
            return (
              <Group
                key={item.id}
                justify="space-between"
                wrap="nowrap"
                p="xs"
                style={{ cursor: 'pointer', borderRadius: 6 }}
                onClick={() => openRequest(item.id)}
              >
                <Group gap="xs" wrap="nowrap" style={{ minWidth: 0, flex: 1 }}>
                  <Badge color={TYPE_META[item.type]?.mantineColor ?? 'gray'} variant="light" size="sm">
                    {item.progressiveNumberFormatted}
                  </Badge>
                  <Box style={{ minWidth: 0 }}>
                    <Text size="sm" fw={500} truncate>
                      {item.title || item.clientName || 'Senza titolo'}
                    </Text>
                    <Text size="xs" c="dimmed" truncate>
                      {item.clientName}
                    </Text>
                  </Box>
                </Group>
                {dueLabel && (
                  <Text size="xs" c={tone === 'danger' ? 'red' : 'orange'} fw={600} style={{ whiteSpace: 'nowrap' }}>
                    {dueLabel}
                  </Text>
                )}
              </Group>
            );
          })}

          {totalCount > items.length && (
            <Text size="xs" c="dimmed" ta="center" mt={4}>
              +{totalCount - items.length} altre
            </Text>
          )}
        </Stack>
      )}
    </Card>
  );
}
